<component
  v-if="shouldRenderConfig"
  v-bind:is="getContainerType"
  v-bind:class="getClassName"
>
  <appProductPartsNames
    v-if="getPPMode=='tabs'"
    v-for="(item,index) in getProductPartsNames"
    v-bind:key="index"
    v-bind:propsData="item"
  >
  </appProductPartsNames>
  <appSelectOption
    v-if="getPPMode=='poptext'"
    :propsData="getProductPartsOption"
    optionType="main"
    v-bind:selectId="'select' + 'getPPMode'"
  ></appSelectOption>
</component>
